import { FC, ReactElement } from 'react';

import styles from './GameBackground.module.css';

export const GameBackgroundConnected: FC = (): ReactElement => {
  return <div className={`${styles.gameBackground}`}></div>;
};
